export default __webpack_public_path__ + "static/media/men-portrait.5aad30f4.svg";